import { HookError } from 'components/ErrorBoundary';
import { ConversationStateType, ConversationReducerActionType } from './types';
import { ACTIONS } from 'constants/hook';

export const initialState: ConversationStateType = {
  isConnected: false,
  isExistingConversation: false,
  isInitializationRequested: false,
  isInactivityTimeout: false,
  isAnimateLastMessage: false,
  messages: [],
  messagesUnreadCount: 0,
  participants: {
    advocates: [],
    customer: [],
    system: [],
  },
  questionInputText: '',
  questionWhenInitializing: '',
  twilio: null,
  unixTimeLastMsgReceived: undefined,
};

export const conversationReducer = (
  state: ConversationStateType,
  action: ConversationReducerActionType,
) => {
  switch (action.type) {
    case ACTIONS.INITIALIZE: {
      return {
        ...state,
      };
    }
    case ACTIONS.CHANGE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACTIONS.RESET: {
      return initialState;
    }
    default: {
      throw new HookError(`Unhandled action type: ${action.type}`);
    }
  }
};
